module.exports = __webpack_public_path__ + "img/storebg.bc4c8010.png";